import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import { Badge, Button, Card, CardBody, Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

import barCode from '../../../src/assets/images/ahlanBarCode.svg';
import { AverageSpending, AverageVisit } from './Components/AreaCharts';
import { MostEngagedCategories } from './Components/BarCharts';
import { CustomerLifeTimeValue } from './Components/ColumnCharts';
import { EngagedScore } from './Components/RadialbarCharts';
import { ChannelPreference, DevicesUsage } from './Components/ECharts';

const Dashboard = () => {
  return (
    <>
      <div className="page-content p-4 pt-0">
        <Row>
          <Col md={12}>
            <div
              style={{ backdropFilter: ' blur(4px)' }}
              className="d-flex justify-content-between gap-4 align-items-center py-4"
            >
              <h4 className="mb-0">Overview</h4>
              <div className="col-sm-auto">
                <div className="input-group">
                  <Flatpickr
                    size="sm"
                    className="form-control  dash-filter-picker border fs-12"
                    options={{
                      mode: 'range',
                      dateFormat: 'd M, Y',
                      defaultDate: ['01 Jan 2022', '31 Jan 2022'],
                    }}
                  />
                  <div className="input-group-text bg-primary border-primary text-white">
                    <i className="ri-calendar-2-line"></i>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={12}>
            <Row>
              <Col lg={3} md={4}>
                <Card className=" shadow-none">
                  <div class="bg-blue-50 p-3 rounded-lg d-flex gap-2 flex-column">
                    <p class="text-sm text-gray-600">Active Members</p>
                    <p class="text-2xl font-bold text-blue-900">14,782</p>
                    <p class="text-xs text-green-600">+12.4% this month</p>
                  </div>
                </Card>
              </Col>
              <Col lg={3} md={4}>
                <Card className=" shadow-none">
                  <div class="bg-indigo-50 p-4 rounded-lg">
                    <p class="text-sm text-gray-600">Redemption Rate</p>
                    <p class="text-2xl font-bold text-indigo-900">68%</p>
                    <p class="text-xs text-green-600">+5.7% this month</p>
                  </div>
                </Card>
              </Col>
              <Col lg={3} md={4}>
                <Card className=" shadow-none">
                  <div class="bg-purple-50 p-4 rounded-lg">
                    <p class="text-sm text-gray-600">Avg. Order Value</p>
                    <p class="text-2xl font-bold text-purple-900">$86.42</p>
                    <p class="text-xs text-green-600">+8.2% this month</p>
                  </div>
                </Card>
              </Col>
              <Col lg={3} md={4}>
                <Card className=" shadow-none">
                  <div class="bg-teal-50 p-4 rounded-lg">
                    <p class="text-sm text-gray-600">Retention Rate</p>
                    <p class="text-2xl font-bold text-teal-900">92%</p>
                    <p class="text-xs text-green-600">+3.5% this month</p>
                  </div>
                </Card>
              </Col>
              <Col md={3}>
                <Card className="border shadow-none">
                  <CardBody className="d-flex gap-2 flex-column">
                    <div className="d-flex gap-2 align-items-center">
                      <div className="avatar-xs flex-shrink-0">
                        <span className="avatar-title bg-danger rounded-circle p-2">
                          <i className="bx bx-scatter-chart"></i>
                        </span>
                      </div>
                      <p className="fw-medium text-muted mb-0 p-0 fs-13">
                        Total Redemption
                      </p>
                    </div>
                    <h2 className="fs-28 card-title mb-0 lh-1">
                      <CountUp start={0} end={500} decimals={0} duration={2} />{' '}
                      AED
                    </h2>
                    <div className="flex-shrink-0">
                      <p className="mb-0 text-muted d-flex justify-content-start  align-items-center gap-1 fs-11">
                        <Badge
                          color="light"
                          className="text-success d-flex justify-content-start align-items-center gap-1"
                        >
                          <i className="align-middle ri-arrow-up-line"></i>
                          <CountUp
                            start={0}
                            end={500}
                            decimals={0}
                            duration={2}
                          />
                          %
                        </Badge>
                        vs. previous day
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card className="border shadow-none">
                  <CardBody className="d-flex gap-2 flex-column">
                    <div className="d-flex gap-2 align-items-center">
                      <div className="avatar-xs flex-shrink-0">
                        <span className="avatar-title bg-danger rounded-circle p-2">
                          <i className="bx bx-scatter-chart"></i>
                        </span>
                      </div>
                      <p className="fw-medium text-muted mb-0 p-0 fs-13">
                        Total Redemption
                      </p>
                    </div>
                    <h2 className="fs-28 card-title mb-0 lh-1">
                      <CountUp start={0} end={500} decimals={0} duration={2} />{' '}
                      AED
                    </h2>
                    <div className="flex-shrink-0">
                      <p className="mb-0 text-muted d-flex justify-content-start  align-items-center gap-1 fs-11">
                        <Badge
                          color="light"
                          className="text-success d-flex justify-content-start align-items-center gap-1"
                        >
                          <i className="align-middle ri-arrow-up-line"></i>
                          <CountUp
                            start={0}
                            end={500}
                            decimals={0}
                            duration={2}
                          />
                          %
                        </Badge>
                        vs. previous day
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md={3}>
                <Card className="border shadow-none">
                  <CardBody className="d-flex gap-2 flex-column">
                    <div className="d-flex gap-2 align-items-center">
                      <div className="avatar-xs flex-shrink-0">
                        <span className="avatar-title bg-danger rounded-circle p-2">
                          <i className="bx bx-scatter-chart"></i>
                        </span>
                      </div>
                      <p className="fw-medium text-muted mb-0 p-0 fs-13">
                        Total Redemption
                      </p>
                    </div>
                    <h2 className="fs-28 card-title mb-0 lh-1">
                      <CountUp start={0} end={500} decimals={0} duration={2} />{' '}
                      AED
                    </h2>
                    <div className="flex-shrink-0">
                      <p className="mb-0 text-muted d-flex justify-content-start  align-items-center gap-1 fs-11">
                        <Badge
                          color="light"
                          className="text-success d-flex justify-content-start align-items-center gap-1"
                        >
                          <i className="align-middle ri-arrow-up-line"></i>
                          <CountUp
                            start={0}
                            end={500}
                            decimals={0}
                            duration={2}
                          />
                          %
                        </Badge>
                        vs. previous day
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col md="12">
                <Card className="border shadow-none">
                  <CardBody className="p-0">
                    <div className="p-3 pb-0">
                      <span className="fs-12 mb-1 text-muted d-block">
                        Brands Engagement
                      </span>
                      <h2 className="fs-24 card-title mb-0">
                        <CountUp
                          start={0}
                          end={500}
                          decimals={0}
                          duration={2}
                        />
                        Nos
                      </h2>
                    </div>
                    <CustomerLifeTimeValue dataColors='["--ak-danger", "--ak-primary", "--ak-success"]' />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Card className="border shadow-none">
              <CardBody className="p-0">
                <div className="p-3 pb-0">
                  <span className="fs-12 mb-1 text-muted d-block">
                    Monthly Customer Joining
                  </span>
                  <h2 className="fs-24 card-title mb-0">
                    AED{' '}
                    <CountUp start={0} end={500} decimals={0} duration={2} />K
                  </h2>
                </div>
                <AverageSpending dataColors='["--ak-primary", "--ak-success"]' />
              </CardBody>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="border shadow-none">
              <CardBody className="p-0">
                <div className="p-3 pb-0">
                  <h5 className="fs-14">Most Engaged Brands</h5>
                </div>
                <MostEngagedCategories dataColors='["--ak-primary", "--ak-secondary", "--ak-success", "--ak-info", "--ak-warning", "--ak-danger"]' />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Dashboard;
